import type { RootState } from "@/app/store";
import { UsuarioLogado } from "@/contexts/autorizacao/usuario/model/UsuarioLogado";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UsuarioLogadoState {
  user: UsuarioLogado;
}

const initialState: UsuarioLogadoState = {
  user: {
    pessoaId: 0,
    nome: "",
    cpfCnpj: "",
    perfil: { id: 0, nome: "", ativo: false, permissoes: [] },
  },
};

const usuarioLogadoSlice = createSlice({
  name: "USUARIO_LOGADO",
  initialState,
  reducers: {
    add: {
      reducer: (state, action: PayloadAction<{ user: UsuarioLogado }>) => {
        const { user } = action.payload;
        state.user = user;
      },
      prepare: (user: UsuarioLogado) => ({
        payload: { user },
      }),
    },
    remove: (state) => {
      state.user = initialState.user;
    },
  },
});

export const usuarioLogadoAction = usuarioLogadoSlice.actions;

export default usuarioLogadoSlice.reducer;

export const getUser = (state: RootState) => {
  return state.usuarioLogado.user;
};
